import React, { useState } from "react";
import RequestService from "../../services/request.service";

import { toast } from 'react-toastify'

import moment from 'moment'
import 'moment/locale/es'


import Pagination from "../../services/Pagination";
import { Table, Form } from 'react-bootstrap'


import ModalNuevoCliente from './ModalNuevoCliente'

import ModalClienteCambiarLogo from './ModalClienteCambiarLogo'

import { SERVER_ } from  '../../config';


const Clientes = () =>{

      // const [ registro, setRegistro ] = useState<any>([])

      // const cargar = async () =>{
      //   try{
      //       let res = await RequestService.getEndPoint('api_route')
      //       setRegistro(res.data)

      //   }
      //   catch(e){
      //     toast.error('Problemas cargando')
      //     toast.error(JSON.stringify(e))
      //   }
      // }

      React.useEffect(() => {
        busqueda()
      }, []);


  const [allSessionsCount,setCounter] = useState(0);
  const sessionsPerPage = 20
  const [currentPage, setCurrentPage] = useState(1);

  const [ text_busqueda, setTextoBusqueda ] = useState('')

  const [ cargando_, setCargando ] = useState( true )

  const skull = { results: [] }

  const [ resultados, setResultados ] = useState<any>({...skull})


  const cargarMiReporte = async(page:number)=>{
    try{
      setCargando(true)
      let skip = 0
      if(page===0) skip = 0; else skip = (page*sessionsPerPage);
      let response : any = await RequestService.getEndPoint('clientes/'+arreglo_estatus+'/busqueda?where='+text_busqueda+'&skip='+skip+'&limit='+sessionsPerPage)
      setCounter(response.data.totalCount)
      setResultados(response.data.resultados)
      setCargando(false)
    }
    catch(e){
      setCargando(false)
      toast.error('Problemas al intentar cargar tus resultados')
    }
  }


  const busqueda = async () =>{
    cargarMiReporte(0)
    setCurrentPage(1)
  }

  const [ arreglo_estatus, setEstatus ] = useState<any>([true,true])


  const todos = () =>{
    setEstatus([true,true])
  }
  const ninguno = () =>{
    setEstatus([false,false])
  }


  const [ show_ModalNuevoCliente, setModalNuevoCliente ] = useState<boolean>(false)
  const handleShow_ModalNuevoCliente = () => {
    setModalNuevoCliente(true)
  }
  const handleClose_ModalNuevoCliente = () => {
    busqueda()
    setModalNuevoCliente(false)
  }







  const [ show_ModalClienteCambiarLogo, setModalClienteCambiarLogo ] = useState<boolean>(false)
  const [ cliente_seleccionado, setClienteSeleccionado ] = useState<any>(null)
  const handleShow_ModalClienteCambiarLogo = (cliente:any) => {
    setClienteSeleccionado(cliente)
    setModalClienteCambiarLogo(true)
  }
  const handleClose_ModalClienteCambiarLogo = () => {
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalClienteCambiarLogo(false)
  }





      return (
          <>

              
<div className="container">


<h3>Clientes</h3>


  <div className="row">
    <div className="col">




        <div className="row">
        
            <div className="">
              <label className="form-label">Búsqueda</label>
              <div className="input-group mb-3">
                <input type="text" className="form-control" onKeyDown={(e)=>{if(e.keyCode === 13){ busqueda() }}} value={text_busqueda} onChange={event => setTextoBusqueda(event.target.value)} />
                <button onClick={busqueda} className="btn btn-default" type="button" ><i className="fa fa-search" /></button>
              </div>
            </div>

{

            // <div>

            //   <Form.Check
            //     inline
            //     name="group1"
            //     type="checkbox"
            //     label="ACTIVO"
            //     checked={arreglo_estatus[0]}
            //     onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[0] = e.target.checked;  setEstatus(ne);}}
            //     id={`opciones_1`}
            //   />
            //   <Form.Check
            //     inline
            //     name="group1"
            //     type="checkbox"
            //     label="INACTIVO"
            //     checked={arreglo_estatus[1]}
            //     onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[1] = e.target.checked;  setEstatus(ne);}}
            //     id={`opciones_2`}
            //   />




            // </div>
            
          // <ul className="list-inline">
          //   <li className="list-inline-item"><small className="cursor" onClick={()=>{todos()}}>Todos</small> / <small className="cursor" onClick={()=>{ninguno()}}>Ninguno</small></li>
          // </ul>
}


          <ul className="list-inline">
            <li className="list-inline-item"><small onClick={handleShow_ModalNuevoCliente} className="pointer">Agregar Cliente</small></li>
          </ul>
        </div>








                          {  (!cargando_) && (

                              <>

                                   {
                                     resultados.length > 0 && (

                                       <>


                                       <h5>Resultados</h5>


                                        <Table responsive="lg">
                                          <thead>
                                            <tr>
                                              <th scope="col"></th>
                                              <th scope="col" colSpan={2}>Cliente</th>
                                              <th scope="col">Teléfono</th>
                                              <th scope="col">Dirección</th>
                                              <th scope="col">Municipio</th>
                                              <th scope="col">Boutiques</th>
                                              <th scope="col"></th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {


                                              resultados.map( (cual:any,indice:number) =>
                                                  <tr key={ Math.random().toString(36).substr(2, 9) } style={{fontSize:12}}>
                                                    <td className="v text-center" style={{"width":"100px"}}>
                                                        <img onClick={(e:any)=>{handleShow_ModalClienteCambiarLogo(cual)}} src={`${SERVER_}cliente/logotipo/${cual.uuid_cliente}?${Math.random().toString(36).substr(2, 9)}`} style={{height:70}} />
                                                    </td>
                                                    <td className="v text-left"  >
                                                      <h6>{cual.cliente}</h6>
                                                    </td>
                                                    <td className="v text-left" style={{"width":"280px"}}>
                                                        <p className="nm">{cual.razon_social}</p>
                                                    </td>
                                                    <td className="v text-left" style={{"width":"120px"}}>
                                                        <p className="nm">{cual.telefono}</p>
                                                        <p className="nm">{cual.email}</p>
                                                    </td>
                                                    <td className="v text-left" style={{"width":"280px"}}>
                                                        <p className="nm">{cual.direccion}, C.P. {cual.cp}</p>
                                                    </td>
                                                    <td className="v text-left" style={{"width":"200px"}}>
                                                        <p className="nm"><b>{cual.estado}</b></p>
                                                        <p className="nm">{cual.municipio}</p>
                                                    </td>
                                                    <td className="v text-center" style={{"width":"80px"}}>
                                                        <p className="nm"><b>{cual.cantidad_boutiques}</b></p>
                                                    </td>
                                                    <td className="v text-left" style={{"width":"40px"}}>
                                                      <a className="btn btn-link" href={`./cliente/${cual.uuid_cliente}`}>
                                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="50" height="50"> <polygon style={{fill:'#C7CFE2'}} points="196.142,461.228 204.693,392.818 307.307,392.818 315.858,461.228 "/> <polygon style={{fill:'#AFB9D2'}} points="311.582,427.023 307.307,392.818 204.693,392.818 200.418,427.023 "/> <path style={{fill:'#5B5D6E'}} d="M486.881,50.772H25.119c-9.446,0-17.102,7.656-17.102,17.102v316.393 c0,9.446,7.656,17.102,17.102,17.102h461.762c9.446,0,17.102-7.656,17.102-17.102V67.875 C503.983,58.429,496.327,50.772,486.881,50.772z"/> <path style={{fill:'#D7DEED'}} d="M8.017,358.614v25.653c0,9.445,7.658,17.102,17.102,17.102h461.762 c9.445,0,17.102-7.658,17.102-17.102v-25.653H8.017z"/> <rect x="42.221" y="84.977" style={{fill:'#FFD782'}} width="427.557" height="239.432"/> <rect x="42.221" y="84.977" style={{fill:'#FFC36E'}} width="427.557" height="25.653"/> <circle style={{fill:'#959CB3'}} cx="418.472" cy="264.551" r="17.102"/> <g> <circle style={{fill:'#AFB9D2'}} cx="367.165" cy="179.04" r="34.205"/> <path style={{fill:'#AFB9D2'}} d="M247.449,281.653c23.614,0,42.756,19.143,42.756,42.756h68.409 c0-61.395-49.771-111.165-111.165-111.165s-111.165,49.771-111.165,111.165h68.409 C204.693,300.796,223.835,281.653,247.449,281.653z"/> </g> <path style={{fill:'#959CB3'}} d="M247.449,281.653c23.614,0,42.756,19.143,42.756,42.756h34.205c0-42.505-34.456-76.96-76.96-76.96 s-76.96,34.456-76.96,76.96h34.205C204.693,300.796,223.835,281.653,247.449,281.653z"/> <path d="M486.881,42.756H25.119C11.268,42.756,0,54.024,0,67.875v316.393c0,13.851,11.268,25.119,25.119,25.119h170.33l-6.26,43.825 H179.04c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017H332.96c4.427,0,8.017-3.589,8.017-8.017 s-3.589-8.017-8.017-8.017h-10.149l-6.26-43.825h170.33c13.851,0,25.119-11.268,25.119-25.119V67.875 C512,54.024,500.732,42.756,486.881,42.756z M25.119,58.789h461.762c5.01,0,9.086,4.076,9.086,9.086v282.722H16.033V67.875 C16.033,62.865,20.109,58.789,25.119,58.789z M306.614,453.211h-101.23l6.261-43.825h88.707L306.614,453.211z M486.881,393.353 H25.119c-5.01,0-9.086-4.076-9.086-9.086V366.63h479.933v17.637C495.967,389.277,491.891,393.353,486.881,393.353z"/> <path d="M42.221,332.426h427.557c4.427,0,8.017-3.589,8.017-8.017V84.977c0-4.427-3.589-8.017-8.017-8.017H42.221 c-4.427,0-8.017,3.589-8.017,8.017v239.432C34.205,328.837,37.794,332.426,42.221,332.426z M247.449,221.261 c54.179,0,98.734,41.987,102.838,95.132h-18.251c-4.054-43.11-40.436-76.96-84.588-76.96s-80.534,33.851-84.588,76.96h-18.249 C148.715,263.248,193.27,221.261,247.449,221.261z M247.449,273.637c-25.268,0-46.278,18.556-50.133,42.756h-18.329 c3.987-34.251,33.159-60.927,68.463-60.927s64.476,26.676,68.463,60.927h-18.328C293.727,292.193,272.716,273.637,247.449,273.637z M281.244,316.392h-67.59c3.63-15.301,17.399-26.722,33.795-26.722C263.845,289.67,277.614,301.091,281.244,316.392z M50.238,92.994 h411.524v223.399h-86.58v-9.086c0-4.427-3.589-8.017-8.017-8.017h-3.207c-3.073-14.268-8.704-27.595-16.394-39.473l2.298-2.298 c3.131-3.131,3.131-8.207,0-11.337l-24.186-24.186c-1.503-1.504-3.542-2.348-5.668-2.348s-4.165,0.844-5.668,2.348l-2.298,2.298 c-11.879-7.69-25.206-13.321-39.473-16.394v-3.207c0-4.427-3.589-8.017-8.017-8.017h-34.205c-4.427,0-8.017,3.589-8.017,8.017v3.207 c-14.268,3.073-27.595,8.704-39.473,16.394l-2.298-2.298c-1.503-1.503-3.542-2.348-5.668-2.348s-4.165,0.844-5.668,2.348 l-24.186,24.186c-3.131,3.131-3.131,8.206,0,11.337l2.298,2.298c-7.69,11.879-13.321,25.206-16.394,39.473h-3.207 c-4.427,0-8.017,3.589-8.017,8.017v9.086h-69.48V92.994z"/> <path d="M324.409,187.056h1.307c1.099,5.692,3.336,10.983,6.479,15.617l-0.931,0.931c-3.131,3.131-3.131,8.206,0,11.337 c1.565,1.566,3.617,2.348,5.668,2.348c2.051,0,4.103-0.782,5.668-2.348l0.931-0.931c4.634,3.141,9.925,5.379,15.617,6.479v1.307 c0,4.427,3.589,8.017,8.017,8.017c4.427,0,8.017-3.589,8.017-8.017v-1.307c5.692-1.099,10.983-3.337,15.617-6.479l0.931,0.931 c1.565,1.566,3.617,2.348,5.668,2.348s4.103-0.782,5.668-2.348c3.131-3.131,3.131-8.206,0-11.337l-0.931-0.931 c3.141-4.634,5.38-9.925,6.479-15.617h1.307c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017h-1.307 c-1.099-5.692-3.336-10.983-6.479-15.617l0.931-0.931c3.131-3.131,3.131-8.206,0-11.337c-3.131-3.131-8.207-3.131-11.337,0 l-0.931,0.931c-4.634-3.141-9.925-5.379-15.617-6.479v-1.307c0-4.427-3.589-8.017-8.017-8.017c-4.427,0-8.017,3.589-8.017,8.017 v1.307c-5.692,1.099-10.983,3.337-15.617,6.479l-0.931-0.931c-3.131-3.131-8.207-3.131-11.337,0c-3.131,3.131-3.131,8.206,0,11.337 l0.931,0.931c-3.141,4.634-5.38,9.925-6.479,15.617h-1.307c-4.427,0-8.017,3.589-8.017,8.017S319.982,187.056,324.409,187.056z M367.165,152.852c14.44,0,26.188,11.748,26.188,26.188s-11.748,26.188-26.188,26.188c-14.44,0-26.188-11.748-26.188-26.188 S352.725,152.852,367.165,152.852z"/> <path d="M367.165,187.099c4.427,0,8.059-3.632,8.059-8.059s-3.632-8.059-8.059-8.059c-4.427,0-8.059,3.632-8.059,8.059 S362.738,187.099,367.165,187.099z"/> <path d="M410.455,238.898v1.853c-3.193,1.079-6.1,2.78-8.575,4.964l-1.616-0.933c-3.835-2.215-8.737-0.9-10.951,2.934 c-2.214,3.834-0.9,8.737,2.934,10.951l1.6,0.924c-0.324,1.604-0.495,3.263-0.495,4.961c0,1.697,0.171,3.356,0.494,4.961l-1.6,0.924 c-3.834,2.214-5.148,7.117-2.934,10.951c1.485,2.572,4.179,4.009,6.95,4.009c1.36,0,2.739-0.346,4.001-1.075l1.616-0.933 c2.476,2.183,5.382,3.885,8.575,4.964v1.853c0,4.427,3.589,8.017,8.017,8.017c4.427,0,8.017-3.589,8.017-8.017v-1.853 c3.193-1.079,6.1-2.78,8.575-4.964l1.616,0.933c1.262,0.729,2.641,1.075,4.001,1.075c2.771,0,5.465-1.438,6.95-4.009 c2.214-3.834,0.9-8.737-2.934-10.951l-1.6-0.924c0.323-1.604,0.494-3.262,0.494-4.961c0-1.698-0.171-3.356-0.494-4.961l1.6-0.924 c3.834-2.214,5.148-7.117,2.934-10.951c-2.214-3.835-7.117-5.148-10.951-2.934l-1.616,0.933c-2.476-2.183-5.382-3.885-8.575-4.964 v-1.853c0-4.427-3.589-8.017-8.017-8.017C414.043,230.881,410.455,234.47,410.455,238.898z M427.557,264.551 c0,5.01-4.076,9.086-9.086,9.086s-9.086-4.076-9.086-9.086c0-5.01,4.076-9.086,9.086-9.086S427.557,259.541,427.557,264.551z"/> <path d="M84.977,135.749h17.102c4.427,0,8.017-3.589,8.017-8.017c0-4.427-3.589-8.017-8.017-8.017H84.977 c-4.427,0-8.017,3.589-8.017,8.017C76.96,132.16,80.55,135.749,84.977,135.749z"/> <path d="M136.284,135.749h94.063c4.427,0,8.017-3.589,8.017-8.017c0-4.427-3.589-8.017-8.017-8.017h-94.063 c-4.427,0-8.017,3.589-8.017,8.017C128.267,132.16,131.857,135.749,136.284,135.749z"/> <path d="M102.079,153.921H84.977c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h17.102c4.427,0,8.017-3.589,8.017-8.017 S106.507,153.921,102.079,153.921z"/> <path d="M136.284,169.954h59.858c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017h-59.858 c-4.427,0-8.017,3.589-8.017,8.017S131.857,169.954,136.284,169.954z"/> <path d="M136.284,204.159h34.205c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017h-34.205 c-4.427,0-8.017,3.589-8.017,8.017S131.857,204.159,136.284,204.159z"/> <path d="M222.33,161.937c0,4.427,3.589,8.017,8.017,8.017H256c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017h-25.653 C225.919,153.921,222.33,157.51,222.33,161.937z"/> <path d="M102.079,188.125H84.977c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h17.102c4.427,0,8.017-3.589,8.017-8.017 S106.507,188.125,102.079,188.125z"/> </svg>
                                                      </a>
                                                    </td>
                                                  </tr>
                                               )
                                            }

                                          </tbody>
                                        </Table>


                                          <Pagination
                                            itemsCount={allSessionsCount}
                                            itemsPerPage={sessionsPerPage}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            cambiarPaginaEvento={cargarMiReporte}
                                            alwaysShown={false}
                                          />


                                        </>



                                       )
                                     
                                   }


                              </>

                           )}

                          {  cargando_ && (

                              <>
                                <div className="loader">
                                  <div className="loaderBar"></div>
                                </div>
                              </>


                           )}



    </div>
  </div>
</div>





  {
    show_ModalNuevoCliente && (
      <ModalNuevoCliente show={show_ModalNuevoCliente} handleClose={handleClose_ModalNuevoCliente}  />
      )

  }



  {
    show_ModalClienteCambiarLogo && (
      <ModalClienteCambiarLogo show={show_ModalClienteCambiarLogo} handleClose={handleClose_ModalClienteCambiarLogo} cliente={cliente_seleccionado} />
      )

  }



          </>

      );
  

}

export default Clientes
